import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ArrowLeft } from "lucide-react";

const PageShell = ({ title, subtitle, children }) => (
  <div className="min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1">
      <div className="bg-slate-50 border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
          <Link to="/" className="text-sm text-slate-600 hover:text-[#16a3a8] inline-flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
          <h1 className="text-2xl sm:text-3xl font-extrabold text-[#0b1e3f] mt-3">{title}</h1>
          {subtitle && <p className="text-sm text-slate-600 mt-1">{subtitle}</p>}
        </div>
      </div>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10 prose-content">
        {children}
      </article>
    </main>
    <Footer />
  </div>
);

export default PageShell;
